import * as React from "react"

import { StaticQuery, graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const Sponsor = () => (
  <StaticQuery
    query={graphql`
      query SponsorQuery {
        allSponsorsJson {
          edges {
            node {
              rank
              class
              entries {
                name
                image
                url
                width
                title
              }
            }
          }
        }
        allPersonalSponsorsJson {
          edges {
            node {
              name
              url
              image {
                childImageSharp {
                  gatsbyImageData(width: 75, height: 75)
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const groups = data.allSponsorsJson.edges.map(edge => edge.node)
      return (
        <section id="sponsors" className="section-padding">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title-header text-center">
                  <h1 className="section-title wow fadeInUp" data-wow-delay="0.2s">Sponsors</h1>
                  <p className="wow fadeInDown" data-wow-delay="0.2s">SRE NEXT 2022 スポンサーリスト</p>
                </div>
              </div>
            </div>
            {groups.map((group, index) => group.entries.length > 0 && (
              <div className="row text-center wow fadeInDown" data-wow-delay="0.3s" key={index}>
                <h2 className={"col-12 sponsor-grade " + group.rank}>{group.rank.toUpperCase()}</h2>
                {group.entries.map((entry, index) => {
                    const image = require('../images/sponsors/' + entry.image)
                    return (
                      <div className={group.class} key={index}>
                        <div className="sponsors-logo">
                          <a href={entry.url} target="_blank" rel="noopener"><img src={image.default} alt={entry.name}
                                                                                  width={entry.width}/></a>
                          {entry.title && (<p>{entry.title}</p>)}
                        </div>
                      </div>
                    )
                  }
                )}
              </div>
            ))}
            <div className="row text-center wow fadeInDown" data-wow-delay="0.3s">
              <h2 className="col-12 sponsor-grade personal">PERSONAL</h2>
              <div className="col-12">
                <div className="sponsors-logo personal">
                  {data.allPersonalSponsorsJson.edges.map(edge => edge.node).map((person, index) => {
                    const image = getImage(person.image)
                    return (
                      <a href={person.url} target="_blank" rel="noopener" key={index}>
                        <GatsbyImage className="img-fluid" image={image} alt={person.name} />
                        <p>{person.name}</p>
                      </a>
                    )
                  })}
                </div>
              </div>
            </div>
          </div>
        </section>
      )
    }}
  />
)

export default Sponsor
